export enum DelegationSubTab {
	Delegations = 'delegations',
	SubAccounts = 'sub-accounts',
}
